module.exports = __webpack_public_path__ + "static/media/castaway.958c89f1.otf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/castaway.otf
// module id = 89
// module chunks = 0